export default {
  name: `menu`,
  entries: [
    {
      name: `carte_ateliers`,
      text: `Carte des ateliers`,
    },
    {
      name: `toggle_fullscreen`,
      text: `Plein écran`,
    },
  ]
}